import { Input } from 'reactstrap';

function CustomFormInput({ ...rest }) {
  return <Input {...rest} />;
}

export default CustomFormInput;
